import {UPDATE_SETTINGS_SITE_DATA} from '../actions/types';
import {
  UPDATE_PRODUCT_DETAILS,
  UPDATE_CATALOG,
  UPDATE_HAS_BEEN_REDIRECTED,
  UPDATE_SUB_ORIGIN,
  UPDATE_ME_MENU_AVAILABLE,
  SESSION_TOKEN_AVAILABLE,
  UPDATE_ME_MENU_LOADING,
} from '../actions/types';
import {v1 as uuidv1} from 'uuid';

const initialState = {
  showFullPage: false,
  productDetails: {},
  catalog: {},
  linkTo: {},
  hasBeenRedirected: false,
  utmSourceOverride: '',
  flowId: uuidv1(),
  subOrigin: 'UHM',
  viewedArticles: [],
  viewingArticle: '',
  iphSearchTerms: [],
  meMenuAvailable: false,
  sessionTokenAvailable: '',
  meMenuLoading: false
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SETTINGS_SITE_DATA:
      let newState = {...action.payload};
      const {linkTo: {key: newKey} = {}} = newState;
      const {linkTo: {key: oldKey} = {}} = state;

      if (typeof oldKey !== 'undefined' && oldKey !== newKey) {
        newState.hasBeenRedirected = false;
      }
      return {...state, ...newState};
    case UPDATE_PRODUCT_DETAILS:
      return {...state, productDetails: {...action.payload}};
    case UPDATE_CATALOG:
      return {...state, catalog: {...action.payload}};
    case UPDATE_HAS_BEEN_REDIRECTED:
      return {...state, hasBeenRedirected: true};
    case UPDATE_SUB_ORIGIN:
      return {...state, subOrigin: action.payload};
    case UPDATE_ME_MENU_AVAILABLE:
      return {...state, meMenuAvailable: action.payload}
    case SESSION_TOKEN_AVAILABLE:
      return {...state, sessionTokenAvailable: action.payload}
    case UPDATE_ME_MENU_LOADING:
      return {...state, meMenuLoading: action.payload}
    default:
      return state;
  }
};

export default settingReducer
